{
  "recommendationAccepted": true,
  "numberOfDocumentsRequested": 2,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "Mojo Mortgages Dev Mode",
  "ownerEmailAddress": "devmode@mojomortgages.com"
}